export default __webpack_public_path__ + "static/media/fcf-and-profitability-1.5b47fa88.png";